/**
 * Type Predicate for checking if the sidebar exists.
 * @param element - The element to check.
 */
export function ElementExists<T extends HTMLElement>(element: Element | null): element is T {
    return element !== null;
}

/**
 * Get the dimensions of the window (can be called within Blazor components).
 */
export function GetWindowDimensions(): { width: number; height: number } {
    console.log("GetWindowDimensions");
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    };
}

/**
 * Check if the device is a mobile device.
 */
export function IsMobile(): boolean {
    return window.innerWidth < 768;
}